import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  barberCard: {
    backgroundColor: colors.cartSurface,
    rowGap: theme.spacing[6],
  },
  barberAvatar: {
    width: 56,
    height: 56,
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.cartAvatarBackground,
  },
  spaceBetween: {
    gap: theme.spacing[4],
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subItemName: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
    maxWidth: '85%',
    _web: {
      maxWidth: '100%',
    },
  },
  subItemNameText: {
    flexShrink: 1,
  },
}));
